module.exports = __webpack_public_path__ + "static/media/country_bb.9f45cdf8.webp";